import { CircularProgress, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import * as ProjectHelper from '../../api/project/projectHelper';
import { route } from '../../route/Index';
import isAdmin from '../../shared/hoc/isAdmin';
import { IProject } from '../../shared/iProject';
import { useAppDispatch } from '../../store/hook';
import { setProject } from '../../store/project/projectSlice';
import { EUnitOfMeasure } from '../../shared/enum';

interface IProjectTemplatePanelProps {}

const ProjectTemplatePanelContainer = styled(Container)`
    padding: 0;
    flex-grow: 1;
`;

const ProjectTemplatePanel = (props: IProjectTemplatePanelProps) => {
    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    const { t } = useTranslation();

    const [projectTemplates, setProjectTemplates] = React.useState<IProject[]>();
    const [isLoading, setIsLoading] = React.useState(false);

    const fetchProjectTemplatePreview = async () => {
        setIsLoading(true);
        let res = await ProjectHelper.getProjectTemplatesAsync();
        setProjectTemplates(res.data);
        setIsLoading(false);
    };

    React.useEffect(() => {
        fetchProjectTemplatePreview();
    }, []);

    const handleGoToProjectTemplateDetail = (unitOfMeasure: EUnitOfMeasure) => {
        let projectTemplate = projectTemplates?.find(x => x.projectInfo.unitOfMeasure == unitOfMeasure);
        dispatch(setProject(projectTemplate!));
        navigate(route.backofficeProjectTemplate.replace(':param', unitOfMeasure.toString()));
    };

    return (
        <ProjectTemplatePanelContainer maxWidth='md'>
            <Stack height='100%' direction='column' spacing={4}>
                <Stack direction='row'>
                    <Typography variant='h1' gutterBottom>
                        {t('projectTemplate')}
                    </Typography>
                </Stack>
                {isLoading && <CircularProgress />}
                {!isLoading && projectTemplates?.length! > 0 && (
                    <Stack flexGrow={1}>
                        <TableContainer>
                            <Table sx={{ minWidth: 650 }} size='small' aria-label='simple table'>
                                <TableHead variant='greenLightWithoutBorder'>
                                    <TableRow>
                                        <TableCell>{t('name')}</TableCell>
                                        <TableCell align='center'>{t('lastUpdate')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {projectTemplates!.map((x, i) => (
                                        <TableRow key={`${x.projectInfo.title}_${i}`} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell onClick={() => handleGoToProjectTemplateDetail(x.projectInfo.unitOfMeasure!)} component='th' scope='row'>
                                                {x.projectInfo.title}
                                            </TableCell>
                                            <TableCell onClick={() => handleGoToProjectTemplateDetail(x.projectInfo.unitOfMeasure!)} align='center'>
                                                {format(x.projectInfo.lastUpdateDate!, 'dd MMMM yyyy')}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Stack>
                )}
            </Stack>
        </ProjectTemplatePanelContainer>
    );
};

export default isAdmin(ProjectTemplatePanel);
